import { Box, Typography } from "@mui/material";
import { ShieldOutlined } from "@mui/icons-material";

export const SecurityBadge = () => {
  return (
    <Box
      sx={{
        position: "absolute",
        bottom: { xs: 8, sm: 16 },
        left: { xs: 8, sm: 16 },
        display: "flex",
        alignItems: "center",
        gap: 1,
        color: "text.secondary",
        zIndex: 10,
        pointerEvents: "none", // Prevents interference with form elements
      }}
    >
      <ShieldOutlined sx={{ fontSize: 16 }} />
      <Typography variant="caption" sx={{ fontSize: "0.75rem" }}>
        Secured by venAuth
      </Typography>
    </Box>
  );
};
